import React, { Component, useState, setState } from 'react'
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker, Select, InputDecimal, DropDownMuti } from '../../components/core';
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal, LockPOModal } from '../../components';
import { addMYearEndPOAction, getMYearEndPOAction, uploadYearEndPOContract, downloadYearEndPOContract, updateLockPOModalAction } from '../../redux/actions/ContractPOAction'
import { AppSettings } from '../../configs'
import { Storage } from "../../configs";
import {
    data_status,
} from '../../configs/datas'
import moment from 'moment'
import { msg } from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from '@material-ui/core/Paper';
import UserServices from '../../services/UserServices';

class ContractPOManageScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            page: 0,
            rowsPerPage: 10,
            data: null,
            searchConditionModel: {
                po_contract_no: '',
                header_text: '',
                vendor: '',
                status: '',
                department_owner: null
            },
            q_rrsnumberFrom: '',
            q_rrsnumberTo: '',
            q_vendorname: '',
            q_po_contract_no: '',
            q_create_po_contract: '',
            q_header_text: '',
            q_goods_recipient: '',
            q_status: '',
            q_requisitioner: '',
            q_unit_requisitioner: '',
            q_procurement_method: '',
            q_doc_invoiceFrom: '',
            q_doc_invoiceTo: '',
            q_ref_invoice_no: '',
            q_purch_group: '',
            q_create_by: '',
            q_create_dateFrom: new Date(),
            q_create_dateTo: '',
            q_edit_by: '',
            q_edit_dateFrom: '',
            q_edit_dateTo: '',
            q_gr_delivery_note: '',
            q_gr_plant: '',
            isAdmin: Storage.getUser().isAdmin,
            appReadonly: true
        }

        //create date
        this.create_date_from_ref = React.createRef();
        this.create_date_to_ref = React.createRef();
        //Edit Date 
        this.edit_date_from_ref = React.createRef();
        this.edit_date_to_ref = React.createRef();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDropdownMutiChange = this.handleDropdownMutiChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleLockStatusChange = this.handleLockStatusChange.bind(this);
        this.setLockPOModal = this.setLockPOModal.bind(this);
        this.refreshData = this.refreshData.bind(this);
    }

    async componentDidMount() {
        
        const user = Storage.getUser();
        if(user){
            await this.setState({
                searchConditionModel:{
                    ...this.state.searchConditionModel,
                    department_owner:user.unitCode
                }
            })
        }

        let { searchConditionModel } = this.state;
        
        await this.props.getMYearEndPO(searchConditionModel);

        this.handleApplicationCheckReadonly()

        const { data } = this.state;
        const { resultSearch } = this.props;
        console.log(resultSearch)
        this.setState({ data: resultSearch })
        $(function () {
            window.onComponentDidMount()
        })
    }

     
    async handleApplicationCheckReadonly()
        {
            UserServices.ApplicationReadonly().then(response=>{
                if(response.data === false)
                {
                    this.setState({appReadonly: false})
                }
            })
        }

    handleChange = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    };
    handleInputChange(event) {
        let { searchConditionModel } = this.state;
        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        searchConditionModel[name] = value;

        this.setState({
            searchConditionModel: searchConditionModel
        })
    }

    handleDropdownMutiChange(event) {
        let { searchConditionModel } = this.state;
        let value = null
        if (event) {
            const target = event.target
            value = event
        }

        searchConditionModel['STATUS'] = value

        console.log("handleDropdownMutiChange")
        console.log(searchConditionModel)
        this.setState({
            searchConditionModel: searchConditionModel
        })
    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    async handleSearch(event) {
        let { searchConditionModel, isAdmin } = this.state;


        event.preventDefault();
        await this.props.getMYearEndPO(searchConditionModel);
        this.setState({ data: this.props.resultSearch });
        if (this.props.resultSearch && this.props.resultSearch.length === 0) {
            msg.error("ไม่พบข้อมูล")
        }


    }
    async refreshData() {
        let { searchConditionModel, isAdmin } = this.state;

        await this.props.getMYearEndPO(searchConditionModel);
        this.setState({ data: this.props.resultSearch });
        if (this.props.resultSearch && this.props.resultSearch.length === 0) {
            msg.error("ไม่พบข้อมูล")
        }
        //await this.props.exportReport(searchConditionModel);

    }
    async handleExport(event) {

        event.preventDefault();
        await this.props.downloadYearEndPOContract();
        if (this.props.resultExport.isSuccess == true) {
            const exportLinkElement = document.createElement('a');
            exportLinkElement.hidden = true;
            exportLinkElement.download = `Template_Lock_PO-Contract_No${moment(new Date()).format("DDMMYYYYhhmm")}.xlsx`;
            exportLinkElement.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + this.props.resultExport.returnMessage;
            exportLinkElement.text = "downloading...";
            document.body.appendChild(exportLinkElement);
            exportLinkElement.click();
            exportLinkElement.remove();
        }
        else {
            msg.error("ไม่พบข้อมูล");
        }
    }

    async handleUpload(event) {

    }
    statusOptions = () => {
        return Promise.resolve([
            {
                value: "Y",
                label: "Yes"
            },
            {
                value: "N",
                label: "No"
            }
        ]);
    }
    handleLockStatusChange(event, dat) {

        const user = Storage.getUser()
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        var __FOUND = this.state.data.findIndex(function (post, index) {
            if (post.po_contract_no == dat.po_contract_no)
                return true;
        });


        let datas = [...this.state.data];

        let data = { ...datas[__FOUND] };

        data.lock_status = value;
        data.updateBy = user.userName;
        datas[__FOUND] = data;
        console.log(data)
        this.setState({ data: datas });

        this.props.addMYearEndPO(data);




    }
    async handleClear(event) {

        event.preventDefault()
        await this.setState({
            searchConditionModel: {
                ...this.state.searchConditionModel,
                po_contract_no: '',
                header_text: '',
                vendor: '',
                status: '',
            }
        })

    }
    onUploadComplete = async () => {
        
        await this.refreshData();
    }
    setLockPOModal(index = "") {

        this.props.updateLockPOModalAction(index)
        // console.log("setUserManualModal", data)
    }

    render() {
        const { searchConditionModel, page, rowsPerPage, data, appReadonly } = this.state;
        const { resultSearch } = this.props;
        console.log(resultSearch)
        //this.setState({data:resultSearch})
        console.log('data', data)

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'จัดการสัญญาผู้ค้าสิ้นปี', url: '' }
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">จัดการสัญญาผู้ค้าสิ้นปี</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">PO / Contract No.</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">

                                            <input
                                                type="text"
                                                id="po_contract_no"
                                                name="po_contract_no"
                                                className="form-control"
                                                placeholder="ข้อมูล Purchase / Contract Number"
                                                maxLength="10"
                                                value={searchConditionModel.po_contract_no}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Header Text</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">


                                            <input
                                                type="text"
                                                id="header_text"
                                                name="header_text"
                                                className="form-control"
                                                placeholder="ชื่องาน"
                                                maxLength="255"
                                                value={searchConditionModel.header_text}
                                                onChange={this.handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_delivery_note" className="rrs-label mb-0">Company</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">

                                            <input
                                                type="text"
                                                id="vendor"
                                                name="vendor"
                                                className="form-control"
                                                placeholder="Vendor Code / Name"
                                                maxLength="255"
                                                value={searchConditionModel.vendor}
                                                onChange={this.handleInputChange}
                                            />

                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <div className="rrs-detail-data">
                                        <label htmlFor="gr_post_date" className="rrs-label mb-0">สถานะ</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="form-group">


                                            <Select
                                                //key={`itemModal_${userModal.item.userName}_${userModal.item.prefix}`}
                                                type="text"
                                                //disabled={roleAdmin ? false : true}
                                                name="status"
                                                defaultValue={null}
                                                className="prefix"
                                                id="status"
                                                onChange={this.handleInputChange}
                                                tagid="user.prefix"
                                                value={searchConditionModel.status}
                                            //autocomplete="off"
                                            //disabled={userModal.item.userGroup === "Reviewer"}
                                            >
                                                <option
                                                    key='0'
                                                    value={''}>
                                                    ทั้งหมด</option>
                                                <option
                                                    key='1'
                                                    value={'Y'}>
                                                    Lock</option>
                                                <option
                                                    key='2'
                                                    value={'N'}>
                                                    Unlock</option>

                                            </Select>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="rrs-detail2">
                                <div className="rrs-form-group-search">
                                    <div className="row justify-content-center mx-0">
                                        <div className="col-md-4" />
                                        <div className="col-md-4">
                                            <a onClick={this.handleSearch} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-search" />
                                            </a>
                                            <a onClick={this.handleClear} style={{ cursor: 'pointer', marginLeft: 10, marginRight: 10 }}>
                                                <i className="icon btn-order-clear" />
                                            </a>

                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "right" }}>
                                            <a onClick={this.handleExport} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-download" />
                                            </a>
                                            { appReadonly === false && <a onClick={this.setLockPOModal} style={{ cursor: 'pointer', marginLeft: 10, marginRight: 10 }} data-toggle="modal" data-target="#lockPOModal">
                                                <i className="icon btn-order-upload" />
                                            </a>}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">


                                        <Table className="sp-table table rrs-table" >
                                            <TableHead>
                                                <TableRow className="sp-table-header">
                                                    <TableCell className="th-table text-center" style={{ width: '100px' }} >PO/Contract No.</TableCell>
                                                    <TableCell className="th-table text-center" style={{ width: '350px' }}>Header Text</TableCell>
                                                    <TableCell className="th-table text-center" style={{ width: '100px' }}>Company</TableCell>
                                                    <TableCell className="th-table text-center" style={{ width: '100px' }}>สถานะ Lock PO / Contract No.</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {

                                                    data ? (
                                                        data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((task, index) => {
                                                                return (
                                                                    <TableRow key={index}>

                                                                        <TableCell   style={{ textAlign: 'center' }} >{task.po_contract_no}</TableCell>
                                                                        <TableCell  style={{ textAlign: 'left' }}>{task.header_text}</TableCell>
                                                                        <TableCell  style={{ textAlign: 'left', "whiteSpace": "nowrap" }}>{task.vendor}</TableCell>
                                                                        <TableCell width="200"  style={{ textAlign: 'center' }}>
                                                                            <div class="row">
                                                                                <div className="col-md-2"/>
                                                                                <div className="col-md-4">
                                                                                    <label className="radiocontainer">Lock
                                                                                        <input
                                                                                            name={"lockStatus" + index}
                                                                                            type="radio"
                                                                                            value={"Y"}
                                                                                            checked={task.lock_status === "Y"}
                                                                                            onChange={(e) => this.handleLockStatusChange(e, task)}
                                                                                        />
                                                                                        <span className="checkmark" />
                                                                                    </label>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <label className="radiocontainer">Unlock
                                                                                        <input
                                                                                        name={"lockStatus" + index}
                                                                                            type="radio"
                                                                                            value={"N"}

                                                                                            checked={task.lock_status === "N"}
                                                                                            onChange={(e) => this.handleLockStatusChange(e, task)}
                                                                                        />
                                                                                        <span className="checkmark" />
                                                                                    </label>
                                                                                </div>
                                                                        
                                                                            </div>


                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })) : (
                                                        <TableRow key={0}>
                                                            <TableCell colSpan="11" className="text-center" style={{
                                                                textAlign: 'center',
                                                                fontStyle: 'italic',
                                                                color: 'gray'
                                                            }}>No data</TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            component="div"
                                            count={resultSearch?resultSearch.length:0}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            backIconButtonProps={{
                                                'aria-label': 'previous page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'next page',
                                            }}
                                            onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                                            onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                                        />



                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <LockPOModal onUploadComplete={() => this.onUploadComplete()} />
            </div >
        )
    }
}

const mapStateToProps = state => {
    const { ContractPORedux } = state
    return {
        resultSearch: ContractPORedux.contractPOData,
        resultExport: ContractPORedux.resultExport,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMYearEndPO: (searchConditionModel) => dispatch(getMYearEndPOAction(searchConditionModel.po_contract_no, searchConditionModel.header_text, searchConditionModel.vendor, searchConditionModel.status, searchConditionModel.department_owner)),
        addMYearEndPO: (model) => dispatch(addMYearEndPOAction(model)),
        uploadYearEndPOContract: (data) => dispatch(uploadYearEndPOContract(data)),
        downloadYearEndPOContract: () => dispatch(downloadYearEndPOContract()),
        updateLockPOModalAction: (data) => dispatch(updateLockPOModalAction(data)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContractPOManageScreen);